import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';

import { Image, SharingPopup, StorageHandler, APIHandler, DataHandler } from 'C4';
import { storageKeys } from 'settings';

const trackShare = (type, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      if (userObj) {
        ({ email } = userObj);
      }
      APIHandler.trackEvent(appId, email, 'collateral', type, value).then(() => {
      });
    });
  });
};

const VideoCollection = (props) => {
  const { chapterCollection } = props;
  const { chapter } = chapterCollection[0];

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(chapterCollection).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = (url, image, title) => ({
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'x',
    },
    baseClass: 'customBox',
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={url} image={image} title={title} />),
    },
    caption: title,
  });

  return (
    <div className="videoGrid__Container">
      <div className="videoGrid__Container--title">
        <h3>{chapter.chapterTitle}</h3>
        <h5>{`Chapter ${chapter.chapterNumber}`}</h5>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="videoGrid__Grid">
            {Object.values(chapterCollection).map((item, index) => {
              const {
                linkJW,
                thumbnail,
                title,
                link,
              } = item;

              return (
                <div className="videoGrid_Holder">
                  <div
                    className="videoGrid_Card"
                    key={linkJW}
                    href={link}
                    style={{ opacity: `${styles[index].pos}` }}
                    data-fancybox={link}
                    data-options={JSON.stringify(fancyOptions(link, thumbnail, title))}
                    data-caption={title}
                    onClick={() => trackShare('collectionItem', link)}
                  >
                    <Image
                      key={linkJW}
                      src={thumbnail || 'https://via.placeholder.com/350x250?text=Placeholder%20Thumbnail'}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                      href={link}
                    />
                  </div>
                  <div className="title">{title}</div>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default VideoCollection;

VideoCollection.propTypes = {
  chapterCollection: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    pageID: PropTypes.number,
    image: PropTypes.string,
    url: PropTypes.string,
    chapter: PropTypes.shape({
      chapterNumber: PropTypes.number,
      chapterTitle: PropTypes.string,
      chapterImage: PropTypes.string,
    }),
  })).isRequired,
};
